import React from 'react';
import { Provider } from 'react-redux';
import store from '../Widget/store';
import Widget from './components/Widget';

function ConnectedWidgetMain({
  title,
  config,
  subtitle,
  widgetBlocks,
  activeWidget,
  setActiveWidget,
  onFormSubmit
}) {
  return (
    <Provider store={store}>
      <Widget 
        title={title}
        config={config}
        subtitle={subtitle}
        widgetBlocks={widgetBlocks}
        activeWidget={activeWidget}
        setActiveWidget={setActiveWidget}
        onFormSubmit={onFormSubmit}
      />
    </Provider>
  );
}

export default ConnectedWidgetMain;
